import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper';
import LeftArrow from '@assets/icons/left_arrow.svg';
import RightArrow from '@assets/icons/right_arrow.svg';
import ReactStars from 'react-rating-stars-component';

import 'swiper/css';
import 'swiper/css/lazy';
import 'swiper/css/grid';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import '@/index.css';
import Skeleton from 'react-loading-skeleton';
const Visitors_1 = ({ content, contentCard }) => {
  return (
    <div className=" container">
      <div className="mx-auto max-w-[1340px] px-4 py-16 sm:px-6 sm:py-24 lg:mr-0 lg:pl-8 lg:pr-0">
        <div className="grid grid-cols-1 gap-y-8 lg:grid-cols-3 lg:items-center lg:gap-x-16">
          <div className="max-w-xl ">
            {(content && (
              <h2 className="text-3xl font-semibold tracking-tight sm:text-4xl text-light-green">
                {content.title}
              </h2>
            )) || (
              <Skeleton
                className="!w-[70%] !h-10 !mb-2"
                count={2}
                baseColor={'#8ff1d7'}
              />
            )}
            {(content && (
              <p className="mt-4 text-gray-500">{content.subtitle}</p>
            )) || (
              <Skeleton
                className=" !h-5 !mb-2"
                count={2}
                baseColor={'#8ff1d7'}
              />
            )}

            <div className="hidden lg:mt-8 lg:flex lg:gap-4 pt-4 rtl:lg:flex-row-reverse rtl:justify-end">
              <button
                aria-label="Previous slide"
                className="prev-button  rounded-md swiper-button-next !opacity-25 hover:!opacity-100  ">
                <img
                  className="object-cover w-full h-auto max-w-[24px]"
                  src={LeftArrow}
                  alt="Left arrow icons"
                  width={16}
                  height={16}
                />
              </button>
              <button
                aria-label="Next slide"
                className=" next-button bg-light-green/50 rounded-md hover:bg-light-green swiper-button-prev">
                <img
                  className="object-cover w-full h-auto max-w-[24px]"
                  src={RightArrow}
                  alt="Right arrow icons"
                  width={16}
                  height={16}
                />
              </button>
            </div>
          </div>
          <div className="-mx-6 lg:col-span-2 lg:mx-0 !overflow-hidden  ">
            <Swiper
              dir="ltr"
              loop={true}
              slidesPerView={1}
              spaceBetween={32}
              autoplay={{ delay: 8000 }}
              breakpoints={{
                200: { slidesPerView: 1 },
                640: { slidesPerView: 1.25 },
                1024: { slidesPerView: 1.5 },
              }}
              navigation={{ nextEl: '.next-button', prevEl: '.prev-button' }}
              modules={[Autoplay, Navigation]}
              className="swiper-container !overflow-hidden">
              <div className="swiper-container !overflow-hidden">
                {(contentCard &&
                  contentCard.map((el, idx) => (
                    <SwiperSlide
                      key={idx}
                      className="!overflow-hidden gradient-custom rounded-xl shadow-md my-5 !w-[unset]">
                      <SwiperSlide className="flex h-full flex-col  justify-between  p-12 !max-w-[300px] md:!max-w-[500px] lg:!max-w-[600px]">
                        <div>
                          <div className=" text-yellow-500">
                            <ReactStars
                              value={el.rate}
                              edit={false}
                              className="!p-0"
                              size={24}
                              emptyIcon={
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="11.187"
                                  height="10.442"
                                  viewBox="0 0 11.187 10.442">
                                  <g
                                    id="Polygon_5"
                                    data-name="Polygon 5"
                                    transform="translate(-0.029 -0.026)"
                                    fill="#cecece"
                                    strokeLinecap="round"
                                    strokeLinejoin="round">
                                    <path
                                      d="M 8.474612236022949 10.21803379058838 C 8.365642547607422 10.21804428100586 8.25919246673584 10.19428443908691 8.158242225646973 10.14740467071533 L 5.727712154388428 9.018874168395996 C 5.694482326507568 9.003444671630859 5.65905237197876 8.995624542236328 5.622422218322754 8.995624542236328 C 5.585792064666748 8.995624542236328 5.550362110137939 9.003444671630859 5.51713228225708 9.018874168395996 L 3.086602210998535 10.14740467071533 C 2.985662221908569 10.19427394866943 2.87922215461731 10.21803379058838 2.770242214202881 10.21803379058838 C 2.55360221862793 10.21803379058838 2.346912145614624 10.1231746673584 2.203152179718018 9.957784652709961 C 2.059512138366699 9.792513847351074 1.997332215309143 9.581164360046387 2.028072118759155 9.362674713134766 L 2.383682250976562 6.834784030914307 C 2.39450216293335 6.757864475250244 2.3683021068573 6.679024219512939 2.313592195510864 6.623884201049805 L 0.4970622062683105 4.793124198913574 C 0.2996122241020203 4.594114303588867 0.2297622114419937 4.304544448852539 0.3147822320461273 4.03740406036377 C 0.3998022079467773 3.77027416229248 0.6241722106933594 3.574334144592285 0.9003221988677979 3.526064157485962 L 3.517602205276489 3.06861424446106 C 3.592102289199829 3.055594205856323 3.655982255935669 3.010244131088257 3.692852258682251 2.944184303283691 L 4.967522144317627 0.6604042649269104 C 5.101891994476318 0.4196542501449585 5.346712112426758 0.2759242355823517 5.622422218322754 0.2759242355823517 C 5.89813232421875 0.2759242355823517 6.142952442169189 0.4196542501449585 6.277322292327881 0.6604042649269104 L 7.551992416381836 2.944194316864014 C 7.588862419128418 3.010244131088257 7.652742385864258 3.055594205856323 7.727241992950439 3.06861424446106 L 10.34451198577881 3.526064157485962 C 10.62067222595215 3.574334144592285 10.84504222869873 3.77027416229248 10.93006229400635 4.03740406036377 C 11.01508235931396 4.304544448852539 10.94523239135742 4.594114303588867 10.74778175354004 4.793124198913574 L 8.931262016296387 6.623884201049805 C 8.876542091369629 6.679024219512939 8.850341796875 6.757864475250244 8.861162185668945 6.834784030914307 L 9.216772079467773 9.362674713134766 C 9.247511863708496 9.581144332885742 9.185332298278809 9.792473793029785 9.041702270507812 9.957734107971191 C 8.897952079772949 10.12314414978027 8.691251754760742 10.21802425384521 8.474612236022949 10.21803379058838 Z"
                                      stroke="none"
                                    />
                                    <path
                                      d="M 5.622422218322754 0.5259246826171875 C 5.451809883117676 0.5259246826171875 5.281197071075439 0.6113643646240234 5.185822010040283 0.7822446823120117 L 3.911152362823486 3.066034317016602 C 3.837752342224121 3.197534084320068 3.708992004394531 3.288954257965088 3.560642242431641 3.314884185791016 L 0.9433717727661133 3.772334098815918 C 0.5454120635986328 3.841894149780273 0.3899822235107422 4.330254077911377 0.6745319366455078 4.617034435272217 L 2.491052627563477 6.447794437408447 C 2.601152420043945 6.558753967285156 2.653021812438965 6.714824199676514 2.631241798400879 6.869614601135254 L 2.275631904602051 9.397503852844238 C 2.220422744750977 9.789923667907715 2.621889114379883 10.08754539489746 2.981322288513184 9.920654296875 L 5.411852359771729 8.792123794555664 C 5.545392513275146 8.730124473571777 5.699451923370361 8.730124473571777 5.832992076873779 8.792123794555664 L 8.263522148132324 9.920654296875 C 8.622953414916992 10.08754444122314 9.024421691894531 9.789924621582031 8.969212532043457 9.397503852844238 L 8.613601684570312 6.869614601135254 C 8.591821670532227 6.714824199676514 8.643692016601562 6.558753967285156 8.753791809082031 6.447794437408447 L 10.5703125 4.617034435272217 C 10.85486221313477 4.330254077911377 10.69943237304688 3.841894149780273 10.30147266387939 3.772334098815918 L 7.684202194213867 3.314884185791016 C 7.535852432250977 3.288954257965088 7.407092094421387 3.197534084320068 7.33369255065918 3.066034317016602 L 6.059022426605225 0.7822446823120117 C 5.963647365570068 0.6113643646240234 5.793034553527832 0.5259246826171875 5.622422218322754 0.5259246826171875 M 5.622422218322754 0.0259246826171875 C 5.984532356262207 0.0259246826171875 6.319122314453125 0.2223539352416992 6.495612144470215 0.5385541915893555 L 7.770292282104492 2.822354316711426 L 10.3875617980957 3.279804229736328 C 10.75577259063721 3.344164371490479 11.05492210388184 3.605404376983643 11.1682825088501 3.961594104766846 C 11.28164196014404 4.317774295806885 11.18852233886719 4.703864097595215 10.92524242401123 4.969204425811768 L 9.108722686767578 6.79996395111084 L 9.464332580566406 9.327854156494141 C 9.504722595214844 9.614864349365234 9.419442176818848 9.904233932495117 9.230381965637207 10.12176418304443 C 9.039112091064453 10.34182453155518 8.763642311096191 10.46803379058838 8.474601745605469 10.46803379058838 C 8.328991889953613 10.46803379058838 8.187131881713867 10.4364538192749 8.052962303161621 10.37415409088135 L 5.622422218322754 9.245624542236328 L 3.191892623901367 10.37415409088135 C 3.057712554931641 10.4364538192749 2.915852546691895 10.46803379058838 2.770242691040039 10.46803379058838 C 2.481192588806152 10.46803379058838 2.205721855163574 10.34182453155518 2.014462471008301 10.12177467346191 C 1.82540225982666 9.904253959655762 1.740121841430664 9.614873886108398 1.780511856079102 9.327844619750977 L 2.13612174987793 6.79996395111084 L 0.3196020126342773 4.969204425811768 C 0.05632209777832031 4.703864097595215 -0.03679752349853516 4.317774295806885 0.07656192779541016 3.961594104766846 C 0.1899223327636719 3.605404376983643 0.4890718460083008 3.344164371490479 0.8572826385498047 3.279804229736328 L 3.474552154541016 2.822354316711426 L 4.749222278594971 0.5385646820068359 C 4.925702095031738 0.2223539352416992 5.260292053222656 0.0259246826171875 5.622422218322754 0.0259246826171875 Z"
                                      stroke="none"
                                      fill="#ebebeb"
                                    />
                                  </g>
                                </svg>
                              }
                              fullIcon={
                                <svg
                                  className="h-5 w-5"
                                  fill="currentColor"
                                  viewBox="0 0 20 20"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                </svg>
                              }
                            />
                          </div>
                          <div className="mt-4">
                            <p className="text-2xl font-bold text-light-green sm:text-3xl">
                              {el.name}
                            </p>
                            <p className="mt-4 leading-relaxed text-gray-500">
                              {el.comment}
                            </p>
                          </div>
                        </div>
                      </SwiperSlide>
                    </SwiperSlide>
                  ))) ||
                  (contentCard.length < 1 && (
                    <Skeleton
                      baseColor={'#8ff1d7'}
                      className="!w-[unset] !min-w-[250px]  lg:!w-[80%] !h-[300px] mx-5 whitespace-nowrap"
                      count={1}
                      inline
                    />
                  ))}
              </div>
            </Swiper>
          </div>
        </div>
        <div className="mt-8 flex justify-center gap-4 lg:hidden rtl:flex-row-reverse">
          <button
            aria-label="Previous slide"
            className="prev-button  rounded-md swiper-button-next !opacity-25 hover:!opacity-100  ">
            <img
              className="object-cover"
              src={LeftArrow}
              alt="Left arrow icons"
              width={16}
              height={16}
            />
          </button>
          <button
            aria-label="Next slide"
            className=" next-button bg-light-green/50 hover:bg-light-green rounded-md  swiper-button-prev">
            <img
              className="object-cover max-w-[24px]"
              src={RightArrow}
              alt="Right arrow icons"
              width={16}
              height={16}
            />
          </button>
        </div>
      </div>
    </div>
  );
};
export default Visitors_1;
